<script lang="ts" setup>
import MaterialSymbolsArrowForwardIosRounded from '~icons/material-symbols/arrow-forward-ios-rounded'
import BLabel from '@/components/common/bLabel.vue'
import ResourceImage from '@/components/resource/resourceImage.vue'

const props = defineProps<{
  evaluation: {
    _id: string
    display: string
    resource: {
      _id: string
      firstname: string
      lastname: string
      picture: string
    }
    project: {
      _id: string
      display: string
    }
  }
}>()
const emit = defineEmits<{
  closeSearch: []
}>()
</script>

<template>
  <RouterLink :to="{ name: 'Evaluation', params: { evaluationId: evaluation._id } }"
    class="w-full flex flex-wrap gap-4 group transition flex cursor-default items-center rounded-md px-2 py-1 group hover:bg-primary-600 hover:cursor-pointer"
    role="option" @click="emit('closeSearch')">

    <div class="flex gap-1">
      <BLabel v-if="evaluation.project" size="dense">
        {{ evaluation.project.display }}
      </BLabel>
      <ResourceImage :resource="evaluation.resource" size="h-6 w-6" />
    </div>
    <p class="ml-3 flex-auto truncate group-hover:text-white">
      {{ evaluation.resource?.firstname||'EMPTY' }} {{ evaluation.resource?.lastname||'EMPTY' }} - {{ evaluation.display }}
    </p>
    <MaterialSymbolsArrowForwardIosRounded class="ml-3 h-5 w-5 flex-none group-hover:text-white" />

  </RouterLink>
</template>
